module.exports = __webpack_public_path__ + "img/circle-down-right.e592051d.svg";